export enum B2CRentalUnitOfMeasure {
  NIGHT = 'Night',
  DAY = 'Day',
  FIXED = 'Fixed',
}
